import { AppThunkAction, AppThunkActionAsync } from '../index';
import agent from 'api/agent';
import globalStore from '../globalStore';
import { FinanceAction } from './actions';
import { parseFileNameFromContentDisposition } from 'helpers/helperFunctions';
import I18n from 'i18n-js';

export const actionCreators = {
    getFinance:
        (
            dateFrom: any,
            dateTo: any,
            restaurantId: string = ''
        ): AppThunkActionAsync<FinanceAction> =>
        (dispatch) => {
            dispatch({
                type: 'GET_FINANCE_DETAILS_START',
            });
            globalStore.actionCreators.showSpiner()(dispatch);
            return agent.Restaurants.GetFinance(dateFrom, dateTo, restaurantId)
                .then((res) => {
                    dispatch({
                        type: 'GET_FINANCE_DETAILS_SUCCESS',
                        payload: res,
                    });
                })
                .catch((e) => {
                    dispatch({
                        type: 'GET_FINANCE_DETAILS_ERROR',
                    });
                    globalStore.actionCreators.showToaster('error', e)(dispatch);
                })
                .finally(() => globalStore.actionCreators.hideSpiner()(dispatch));
        },
    getFinanceExcel:
        (dateFrom: string, dateTo: string, restaurantId?: string): AppThunkAction<FinanceAction> =>
        (dispatch) => {
            globalStore.actionCreators.showSpiner()(dispatch);
            agent.Restaurants.GetFinanceExcel(dateFrom, dateTo, restaurantId)
                .then((res) => {
                    const blob = res.data;
                    const filename = parseFileNameFromContentDisposition(
                        res.headers['content-disposition'],
                        'finance',
                        'xlsx'
                    );
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    a.click();
                    a.remove();
                    URL.revokeObjectURL(url);
                })
                .catch((e) => {
                    globalStore.actionCreators.showToaster('error', e)(dispatch);
                })
                .finally(() => globalStore.actionCreators.hideSpiner()(dispatch));
        },
    getPaymentReport:
        (from: string, to: string, restaurantId: string = ''): AppThunkActionAsync<FinanceAction> =>
        (dispatch) => {
            globalStore.actionCreators.showSpiner()(dispatch);
            return agent.Restaurants.GetPaymentsReport(from, to, restaurantId)
                .then((res) => {
                    dispatch({
                        type: 'GET_PAYMENT_REPORT_SUCCESS',
                        payload: res,
                    });
                })
                .catch((e) => {
                    globalStore.actionCreators.showToaster(
                        'error',
                        I18n.t('common.somethingWrong')
                    )(dispatch);
                })
                .finally(() => globalStore.actionCreators.hideSpiner()(dispatch));
        },
    getPaymentReportExcel:
        (from: string, to: string, restaurantId: string = ''): AppThunkAction<FinanceAction> =>
        (dispatch) => {
            globalStore.actionCreators.showSpiner()(dispatch);
            agent.Restaurants.GetPaymentsReportExcel(from, to, restaurantId)
                .then((res) => {
                    const blob = res.data;
                    const filename = parseFileNameFromContentDisposition(
                        res.headers['content-disposition'],
                        'finance',
                        'xlsx'
                    );
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    a.click();
                    a.remove();
                    URL.revokeObjectURL(url);
                })
                .catch((e) => {
                    globalStore.actionCreators.showToaster('error', e)(dispatch);
                })
                .finally(() => globalStore.actionCreators.hideSpiner()(dispatch));
        },
    getGroupSales:
        (groupId: string, from: string, to: string): AppThunkActionAsync<FinanceAction> =>
        (dispatch) => {
            globalStore.actionCreators.showSpiner()(dispatch);
            return agent.Restaurants.GetGroupSalesReport(groupId, from, to)
                .then((res) => {
                    dispatch({
                        type: 'GET_GROUP_SALES',
                        payload: res,
                    });
                })
                .catch((e) => {
                    globalStore.actionCreators.showToaster('error', e)(dispatch);
                })
                .finally(() => globalStore.actionCreators.hideSpiner()(dispatch));
        },
    getGroupSalesExcel:
        (groupId: string, from: string, to: string): AppThunkAction<FinanceAction> =>
        (dispatch) => {
            globalStore.actionCreators.showSpiner()(dispatch);
            agent.Restaurants.GetGroupSalesExcel(groupId, from, to)
                .then((res) => {
                    const blob = res.data;
                    const filename = parseFileNameFromContentDisposition(
                        res.headers['content-disposition'],
                        'finance',
                        'xlsx'
                    );
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    a.click();
                    a.remove();
                    URL.revokeObjectURL(url);
                })
                .catch((e) => {
                    globalStore.actionCreators.showToaster('error', e)(dispatch);
                })
                .finally(() => globalStore.actionCreators.hideSpiner()(dispatch));
        },
    getGroupPaymentReport:
        (groupId: string, from: string, to: string): AppThunkActionAsync<FinanceAction> =>
        (dispatch) => {
            globalStore.actionCreators.showSpiner()(dispatch);
            return agent.Restaurants.GetGroupPaymentReport(groupId, from, to)
                .then((res) => {
                    dispatch({
                        type: 'GET_GROUP_PAYMENTS',
                        payload: res,
                    });
                })
                .catch((e) => {
                    globalStore.actionCreators.showToaster(
                        'error',
                        I18n.t('common.somethingWrong')
                    )(dispatch);
                })
                .finally(() => globalStore.actionCreators.hideSpiner()(dispatch));
        },
    getGroupPaymentReportExcel:
        (from: string, to: string, restaurantId: string = ''): AppThunkAction<FinanceAction> =>
        (dispatch) => {
            globalStore.actionCreators.showSpiner()(dispatch);
            agent.Restaurants.getGroupPaymentReportExcel(from, to, restaurantId)
                .then((res) => {
                    const blob = res.data;
                    const filename = parseFileNameFromContentDisposition(
                        res.headers['content-disposition'],
                        'finance',
                        'xlsx'
                    );
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    a.click();
                    a.remove();
                    URL.revokeObjectURL(url);
                })
                .catch((e) => {
                    globalStore.actionCreators.showToaster('error', e)(dispatch);
                })
                .finally(() => globalStore.actionCreators.hideSpiner()(dispatch));
        },
};
